<template>
  <el-container id="user-group">
    <el-header height="55px" class="header">
      <el-button-group>
        <el-button icon="el-icon-plus" @click="addGroupLayer=true" size="small">新建集合</el-button>
        <el-button icon="el-icon-refresh" @click="pageRefresh" size="small">刷新</el-button>
      </el-button-group>
      <el-button
        type="danger"
        icon="el-icon-delete"
        size="small"
        :disabled="selectionList.length===0"
        @click="removeAction"
        style="margin-left:60px">批量移除</el-button>
    </el-header>
    <el-container>
      <el-aside class="aside" width="220px">
        <template v-if="groupList.length>0">
          <side-item
            :current-item="activeGroup"
            v-for="item in groupList"
            v-context-menu="contextMenu(item)"
            :data="item"
            :key="item.id"
            @currentChange="currentChange">
          </side-item>
        </template>
        <template v-if="groupList.length===0">
          <div style="width:100%;height:100px;text-align:center;line-height:100px;color:#555;font-size:15px">暂无数据</div>
        </template>
      </el-aside>
      <el-main class="main-content">
        <table-component
          :table-data="tableData"
          :border="false"
          :page="page"
          :total="total"
          :size="per_page"
          @current-change="currentPageChange"
          @selection-change="selectionChange">
        </table-component>
      </el-main>
    </el-container>
    <!-- 新建用户集合 layer -->
    <mask-layer v-show="addGroupLayer" v-model="addGroupLayer">
      <div class="add-group">
        <el-form class="el-form" ref="newGroupForm" :model="newGroupForm" :rules="rules" label-width="80px">
          <h3>创建用户集合</h3>
          <el-form-item label="集合名称" prop="name">
            <el-input v-model="newGroupForm.name" clearable placeholder="请输入集合名称"></el-input>
          </el-form-item>
          <el-form-item label="集合描述">
            <el-input type="textarea" v-model="newGroupForm.intrdution" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="newGroupForm.name===''" @click="addGroup">立即创建</el-button>
            <el-button @click="addGroupLayer=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </mask-layer>
    <!-- 更新集合信息 layer -->
    <mask-layer v-show="updateGroupLayer" v-model="updateGroupLayer">
      <div class="add-group">
        <el-form class="el-form" ref="updateGroupForm" label-width="80px">
          <h3>编辑用户集合</h3>
          <el-form-item label="原始值">
            <p>{{selectGroup.name}}</p>
          </el-form-item>
          <el-form-item label="更改为">
            <el-input v-model="updateGroupForm.name" clearable placeholder="请输入集合名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="updateGroupForm.name===''" @click="updateGroup">保存更改</el-button>
            <el-button @click="updateGroupLayer=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </mask-layer>
    <selection
    v-show="selectionLayer"
    v-model="selectionLayer"
    :send-data="data.sendData"
    :url="data.url"
    @confirm="confirmHandle"></selection>
  </el-container>
</template>
<script>
import request from '@/utils/request'
import SideItem from '@/components/SideItem/SideItem'
import TableComponent from '@/components/Table'
import MaskLayer from '@/components/MaskLayer'
import Selection from '@/components/Selection'

export default {
  name: 'UserGroup',
  components: {
    SideItem,
    TableComponent,
    MaskLayer,
    Selection
  },
  data () {
    return {
      groupList: [], // 用户集合
      activeGroup: '', // 当前选中集合
      userList: [], // 当前集合成员
      total: 0, // 集合成员数目
      page: 1, // 当前页码
      per_page: 15, // 每页展示数目
      addGroupLayer: false, // 控制创建集合弹出框
      newGroupForm: { // 创建集合信息
        name: '', // 名称
        type: 'user', // 类型
        intrdution: '' // 描述
      },
      rules: { // 创建集合信息表单验证规则
        name: [
          { required: true, message: '请输入集合名称', trigger: 'blur' }
        ]
      },
      selectionLayer: false,
      selectGroup: '', // 右键菜单操作的集合
      data: {
        url: 'users',
        sendData: ''
      },
      selectionList: [], // 批量移除 list
      updateGroupLayer: false,
      updateGroupForm: {
        name: ''
      }
    }
  },
  watch: {
    selectGroup: function () {
      this.updateGroupForm.name = this.selectGroup.name
    }
  },
  mounted () {
    this.pageRefresh()
  },
  methods: {
    // 刷新页面 or 初始化数据
    pageRefresh () {
      let _this = this
      let sendData = {
        type: 'user'
      }
      request({
        url: 'collections',
        method: 'get',
        params: sendData
      }).then(res => {
        _this.groupList = res.data.list
        if (!_this.activeGroup) {
          _this.activeGroup = res.data.list[0] || ''
        }
        if (_this.activeGroup) {
          _this.activeGroupList()
        }
      })
    },
    // 获取当前选中用户集合成员数据
    activeGroupList () {
      let _this = this
      let sendData = {
        collection: this.activeGroup.id,
        page: this.page,
        per_page: this.per_page
      }
      request({
        url: 'users',
        method: 'get',
        params: sendData
      }).then(res => {
        _this.userList = res.data.list
        _this.total = res.data.item_total
      })
    },
    // 当前选中用户集合改变，重置初始数据
    currentChange (data) {
      this.page = 1
      this.activeGroup = data
      this.selectionList = []
      this.activeGroupList()
    },
    // table 页码改变
    currentPageChange (page) {
      this.page = page
      this.activeGroupList()
    },
    // 新建用户集合
    addGroup () {
      let _this = this
      let sendData = {
        name: this.newGroupForm.name,
        type: this.newGroupForm.type
      }
      request({
        url: 'collections',
        method: 'post',
        data: sendData
      }).then(res => {
        _this.pageRefresh() // 刷新页面
        _this.addGroupLayer = false // 隐藏新建集合 layer
      })
    },
    // 更新集合
    updateGroup () {
      let _this = this
      let sendData = {
        attributes: {
          name: this.updateGroupForm.name
        },
        type: 'update_attribute'
      }
      request({
        url: 'collections/' + this.selectGroup.uuid,
        method: 'patch',
        data: sendData
      }).then(res => {
        _this.pageRefresh() // 刷新页面
        _this.updateGroupLayer = false // 隐藏新建集合 layer
        _this.selectGroup.name = _this.updateGroupForm.name
      })
    },
    // 用户勾选批量移除 checkbox
    selectionChange (e) {
      this.selectionList = e
    },
    // 批量移除操作
    removeAction () {
      let _this = this
      let list = this.selectionList
      this.$confirm('从 ' + this.activeGroup.name + ' 中移除选中项，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arrId = []
        for (let i = 0; i < list.length; i++) {
          arrId.push(list[i].id)
        }
        let sendData = {
          type: 'remove',
          items: arrId
        }
        request({
          url: 'collections/' + this.activeGroup.uuid + '/users/batch',
          method: 'post',
          data: sendData
        }).then(res => {
          _this.pageRefresh() // 刷新页面
        })
      }).catch(() => {})
    },
    // 确认添加
    confirmHandle (e) {
      let arrId = []
      for (let i = 0; i < e.length; i++) {
        arrId.push(e[i].id)
      }
      let _this = this
      let sendData = {
        type: 'add',
        items: arrId
      }
      request({
        url: 'collections/' + this.selectGroup.uuid + '/users/batch',
        method: 'post',
        data: sendData
      }).then(res => {
        // 隐藏选择框
        _this.selectionLayer = false
        _this.activeGroup = _this.selectGroup
        _this.pageRefresh()
      })
    },
    menuDeleteHandle (item) {
      let _this = this
      this.$confirm('删除集合列表 ' + item.name + '，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        request({
          url: 'collections/' + item.uuid,
          method: 'delete'
        }).then(res => {
          _this.activeGroup = ''
          _this.pageRefresh() // 刷新页面
        })
      }).catch(() => {})
    },
    // 右键菜单回调
    contextMenuCallback (item, type) {
      console.log(item)
      this.selectGroup = item
      switch (type) {
        case 'edit':
          this.updateGroupLayer = true
          break
        case 'delete':
          this.menuDeleteHandle(item)
          break
        case 'add':
          this.selectionLayer = true
          this.data.sendData = {
            exclude_collection: item.id
          }
          break
      }
    },
    // 右键菜单参数
    contextMenu (item) {
      return {
        data: item,
        callback: this.contextMenuCallback,
        menulist: [
          {
            label: '编辑',
            type: 'edit'
          },
          {
            label: '删除',
            type: 'delete'
          },
          {
            label: '添加成员',
            type: 'add'
          }
        ]
      }
    }
  },
  computed: {
    tableData: function () {
      return {
        props: [
          {
            label: '头像',
            type: 'img',
            prop: 'headimg',
            width: '120'
          },
          {
            label: '名称',
            type: 'string',
            prop: 'name'
          },
          {
            label: '性别',
            type: 'string',
            prop: 'gender'
          },
          {
            label: '手机号',
            type: 'string',
            prop: 'phone'
          },
          {
            label: '积分',
            type: 'string',
            prop: 'score'
          },
          {
            label: '注册日期',
            type: 'time',
            prop: 'created_at'
          }
        ],
        list: this.userList,
        selection: true
      }
    }
  }
}
</script>
<style lang="less" scoped>
#user-group {
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: 1px solid #E4E7ED;

  .header {
    border-bottom: 1px solid #EBEEF5;
    line-height: 55px;
    padding: 0 10px;
  }

  .aside {
    border-right: 1px solid #EBEEF5;
    overflow-y:auto;
    box-sizing: border-box;
  }

  .main-content {
    overflow-y: auto;
    padding: 0 0 10px 0;
  }

  .add-group {
    width: 700px;

    .el-form {
      width: 600px;
      margin: 10px auto;

      h3 {
        color: #333333;
        text-align: center;
        margin-bottom: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/group.vue